
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    getProductComponent() {
      const productRoot = this.closest('[data-island]');
      if (!productRoot || typeof Alpine === 'undefined') return null;
      return Alpine.$data(productRoot);
    }

    setLoading(isLoading) {
      const product = this.getProductComponent();
      const label = this.submitButton?.querySelector('.push-btn__surface');
      if (product) product.loading = isLoading;
      if (isLoading && typeof liveRegion === 'function') {
        liveRegion(window.theme.strings.addingToCart);
      }
      if (!label) return;
      if (isLoading) {
        label.textContent = window.theme.strings.addingToCart;
      } else if (product?.currentVariant && !product.currentVariant.available) {
        label.textContent = window.theme.strings.soldOut;
      } else {
        label.textContent = window.theme.strings.addToCart;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
    
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.error = false;

      this.setLoading(true);
      this.submitButton.setAttribute('aria-disabled', 'true');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      const cartData = {};

      const is_bundle = formData.get('is_bundle');
      
      if(is_bundle == "true" && this.form.dataset.byoProductId) {
        const bundleProductData = {
          productId: this.form.dataset.byoProductId,
          variantId: this.form.dataset.byoVariantId,
          sellingPlan: 688741024025,
          handle: this.form.dataset.byoHandle,
        }
        
        const bundle = {
          "externalVariantId": bundleProductData.variantId,
          "externalProductId": bundleProductData.productId,
          "selections": [
            {
              "collectionId": this.form.dataset.byoBaseCollectionId,
              "externalProductId": this.form.dataset.productId,
              "externalVariantId": formData.get('id'),
              "quantity": formData.get('quantity'),
              "sellingPlan": formData.get('selling_plan'),
            }
          ]
        };
        const customizations = this.form.querySelectorAll('input[name="customizations[]"]');
        customizations.forEach((customization) => {
          bundle.selections.push({
            "collectionId": customization.dataset.collectionId,
            "externalProductId": customization.dataset.productId,
            "externalVariantId": customization.value,
            "quantity": formData.get('quantity'),
            "sellingPlan": this.mapSellingPlan(customization.dataset.productId, formData.get('selling_plan'))
          });
        });

        const cartItems = recharge.bundle.getDynamicBundleItems(bundle, bundleProductData.handle);
        if(formData.get('properties[Mix Name]')) {
          cartItems[0].properties.Mix_Name = formData.get('properties[Mix Name]');
        }

        cartData.items = cartItems;
        
        formData.delete('quantity');
        formData.delete('selling_plan');
        formData.delete('id');
      } 
      
      for (const [key, value] of formData) {
        cartData[key] = value;
      }

      const modalCart = window.theme?.settings?.cartType === 'modal';
      if (modalCart) {
        cartData.sections = 'cart-items,cart-footer,cart-item-count';
        cartData.sections_url = window.location.pathname;
      }

      config.body = JSON.stringify(cartData);
      config.headers['Content-Type'] = 'application/json';

      fetch(`${window.theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
               
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!modalCart) {
            window.location = window.theme.routes.cart_url;
            return;
          }

          if (!response.sections) {
            try {
              const sectionsRes = await fetch(
                `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
              );
              response.sections = await sectionsRes.json();
            } catch (e) {
              console.error(e);
            }
          }

          this.error = false;

          document.body.dispatchEvent(
            new CustomEvent('shapes:cart:afteradditem', {
              bubbles: true,
              detail: { response, sourceId: this.form.id }
            })
          );
        })
        .catch((e) => {
          console.error(e);
          this.error = true;
        })
        .finally(() => {
          this.setLoading(false);
          this.submitButton.classList.remove('loading');
          document.dispatchEvent(new Event('cart:updated'));
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    mapSellingPlan(bundle_product_id, user_selected_selling_plan_id) {
      if(selling_plans_map[this.form.dataset.productId]) {
        const delivery_every = selling_plans_map[this.form.dataset.productId][user_selected_selling_plan_id];
        if(delivery_every) {
          for (const key in selling_plans_map[bundle_product_id]) {
            const value = selling_plans_map[bundle_product_id][key];
            if(value) {
              if(value.toLowerCase() == delivery_every.toLowerCase()) {
                return key;
              }
            }
          }
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
